module.exports = __webpack_public_path__ + "static/wedding_6-dbfe6c0c1f0cdf6d33806196458b2881.jpg";